import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useViewerRoles } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import {
	AddIcon,
	Button,
	Card,
	Empty,
	FlexGap,
	Paragraph,
	SettingsSection,
	Spinner,
	tokens,
} from '@treams/treams-ui';

import GoalDriverEdit from '../../../../kakapo-ui-kit/components/goals/drivers/GoalDriverEdit';

export default function GoalDriverSettingsContainer() {
	const { t } = useTranslation();
	const { isHRBusinessPartner } = useViewerRoles();

	const [adding, setAdding] = useState(false);
	const [showArchived, setShowArchived] = useState(false);

	const queries = {
		active: graphql.useGoalDriversQuery(),
		archive: graphql.useGoalDriversQuery({ variables: { isArchived: true } }),
	};

	const goalDrivers = queries.active?.data?.goalDrivers;
	const archivedGoalDrivers = queries.archive?.data?.goalDrivers;

	const onRefresh = async () => {
		await queries.active.refetch();
		await queries.archive.refetch();
		setAdding(false);
	};

	return (
		<FlexGap flexDirection="column" gap={tokens.gap.page} width="100%">
			<FlexGap flexDirection="column" gap={tokens.gap.group} width="100%">
				<FlexGap alignItems="center" justifyContent="space-between" width="100%">
					<Paragraph mb={0} mr={3}>
						{t('organization.drivers.description')}
					</Paragraph>
					{!isHRBusinessPartner && (
						<Button
							type="secondary"
							icon={<AddIcon />}
							title={t('organization.drivers.add')}
							onClick={() => setAdding(true)}
						/>
					)}
				</FlexGap>
				{goalDrivers ? (
					goalDrivers.length > 0 || adding ? (
						<Card p={0}>
							{goalDrivers.map((driver) => (
								<GoalDriverEdit
									key={driver.id}
									driver={driver as graphql.GoalDriver}
									onRefresh={onRefresh}
								/>
							))}
							{adding && <GoalDriverEdit onRefresh={onRefresh} />}
						</Card>
					) : (
						<Empty.Card title={t('organization.drivers.empty')} />
					)
				) : (
					<Spinner />
				)}
			</FlexGap>

			{showArchived ? (
				<SettingsSection title={t('organization.drivers.archived.title')}>
					<Paragraph mb={0}>{t('organization.drivers.archived.description')}</Paragraph>
					{archivedGoalDrivers ? (
						archivedGoalDrivers.length > 0 ? (
							<Card p={0}>
								{archivedGoalDrivers.map((driver) => (
									<GoalDriverEdit
										key={driver.id}
										driver={driver as graphql.GoalDriver}
										onRefresh={onRefresh}
									/>
								))}
							</Card>
						) : (
							<Empty.Card title={t('organization.drivers.archived.empty')} />
						)
					) : (
						<Spinner />
					)}
				</SettingsSection>
			) : (
				(archivedGoalDrivers?.length ?? 0) > 0 && (
					<Button
						type="secondary"
						title={t('organization.drivers.archived.button.title')}
						onClick={() => setShowArchived(true)}
					/>
				)
			)}
		</FlexGap>
	);
}
